import iziToast from "izitoast";
import "izitoast/dist/css/iziToast.min.css";
                                                    // Функція для показу повідомлень користувачу
import { getImagesByQuery } from "./js/pixabay-api";
import { createGallery, clearGallery, showLoader, hideLoader, showLoadMoreButton, 
    hideLoadMoreButton } from "./js/render-functions";

const form = document.querySelector('.form');
const loadMoreBtn = document.querySelector('.load-more');

let query = '';                                     // Поточний пошуковий запит
let page = 1;                                       // Номер сторінки
let maxPage = 0;                                    // Максимальний номер сторінки
const perPage = 15;                                 // Кількість зображень на сторінці

form.addEventListener('submit', async event => {
    event.preventDefault();                         // Відміняю стандартну поведінку форми
    
                                                    // Отримую значення пошукового запиту і обрізаю пробіли
    const userQuery = event.target.elements['search-text'].value.trim();

    if (userQuery === '') {                         // Якщо запит порожній, показую повідомлення і виходжу з функції
        iziToast.warning({ message: "Please enter a search query!", position: 'topRight' });
        return;
    }
    query = userQuery;                              // Оновлюю поточний пошуковий запит
    page = 1;                                       // Скидаю номер сторінки до першої
    clearGallery();                                 // Очищую галерею перед новим пошуком
    showLoader();                                   // Показую лоадер
    hideLoadMoreButton();                           // Ховаю кнопку "Завантажити ще" перед новим пошуком

    try {                                           // Отримую зображення за поточним запитом і сторінкою
        const data = await getImagesByQuery(query, page);

        maxPage = Math.ceil(data.totalHits / perPage);// Обчислюю максимальний номер сторінки
        createGallery(data.hits);                   // Створюю галерею з отриманих зображень
        
        if (data.hits.length === 0) {               // Якщо зображень немає, показую повідомлення        
            iziToast.info({ message: "Sorry, there are no images matching your search query. Please try again!", position: 'topRight' });
            return;
        }

        if (maxPage > 1) {
            showLoadMoreButton();                   // Якщо є ще сторінки, показую кнопку "Завантажити ще"
        } else {
            hideLoadMoreButton();                   // Якщо все вмістилось на 1 сторінку
            iziToast.error({ message: "We're sorry, but you've reached the end of search results.", position: 'topRight' });
        }

    } catch (error) {
        console.log(error);                         // Логую помилку в консоль
                                                    // Показую повідомлення про помилку користувачу
        iziToast.error({ message: 'Something went wrong! Please try again later.', position: 'topRight' });
    } finally {
        hideLoader();                               // Ховаю лоадер
        form.reset();                               // Скидаю форму пошуку
    }
}); 

loadMoreBtn.addEventListener('click', async () => {
    page += 1;                                      // Збільшую номер сторінки
    showLoader();                                   // Показую лоадер під час завантаження зображень
    hideLoadMoreButton();                           // Ховаю кнопку "Завантажити ще" під час завантаження
    
    try {
        const data = await getImagesByQuery(query, page);
        createGallery(data.hits);                   // Додаю отримані зображення до галереї

        smoothScroll();                             // Виконую плавний скрол до нових зображень

        hideLoader();                               // Ховаю лоадер після завантаження зображень

        if (page >= maxPage) {                      // Якщо досягнуто останньої сторінки, ховаю кнопку "Завантажити ще"               
            hideLoadMoreButton();
            iziToast.info({ message: "We're sorry, but you've reached the end of search results.", position: 'topRight' });
        } else {
            showLoadMoreButton();                   // Інакше показую кнопку "Завантажити ще"
        }

    } catch (error) {      
                                                    // Показую повідомлення про помилку користувачу
        iziToast.error({ message: 'Something went wrong!', position: 'topRight' });
    } finally {
        hideLoader();                               // Ховаю лоадер
    }    
});

                                                    // Функція плавного скролу
function smoothScroll() {
                                                    // Знаходжу перший елемент галереї
    const firstCard = document.querySelector('.gallery-item');
    if (firstCard) {                                // Отримую висоту одного елемента галереї            
        const cardHeight = firstCard.getBoundingClientRect().height;
        window.scrollBy({
            top: cardHeight * 2,
            behavior: 'smooth',
        });
    }
}